import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';

interface NameInputProps {
  value: string;
  onChange: (text: string) => void;
  error?: string;
}

const NameInput: React.FC<NameInputProps> = ({ value, onChange, error }) => (
  <View style={styles.wrapper}>
    <Text style={styles.label}>Charger Name</Text>
    <TextInput
      style={styles.input}
      placeholder="Enter charger name"
      placeholderTextColor="#8D8E90"
      value={value}
      onChangeText={onChange}
      autoComplete='off'
      autoCorrect={false}
    />
    {error ? 
        <Text style={styles.error}>
            {error}
        </Text> : null}
  </View>
);

const styles = StyleSheet.create({
  wrapper: { 
    marginBottom: 16
   },
  label: { 
    color: '#fff', 
    marginBottom: 4, 
    fontWeight: '600' 
  },
  input: { 
    backgroundColor: '#292D33', 
    color: '#fff', 
    padding: 12, 
    borderRadius: 24 
  },
  error: { 
    color: 'red', 
    marginTop: 4 
  },
});

export default NameInput;